
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    RANGEPUTTING_ACTION,
    FETCH_RANGEPUTTING,
    ADD_RANGEPUTTING,
    GET_RANGEPUTTING,
    EDIT_RANGEPUTTING,
    DELETE_RANGEPUTTING,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Range Intervention Putting Actions
 */

    export const fetchRangePutting = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEPUTTING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangeputting', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEPUTTING, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangePutting = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEPUTTING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangeputting', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangePutting(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEPUTTING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangePutting = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEPUTTING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangeputting', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEPUTTING, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangePutting = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEPUTTING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangeputting', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangePutting(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEPUTTING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangePutting = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEPUTTING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangeputting', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangePutting(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEPUTTING});                    
                }
                
                
            });
        
        }
    }


    